"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var Pages_1 = require("@/rendering/common/Pages");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var mapStateToProps = function (state, ownProps) { return (__assign(__assign({}, state.callOrEmail), { page: state.page, t: state.translate })); };
var mapDispatchToProps = function (dispatch) { return ({
    enquireClicked: function () { return dispatch(LayoutAction_1.default.onContactClicked()); },
    callClicked: function () { return dispatch(LayoutAction_1.default.onCallClicked()); },
    whatsAppClicked: function () { return dispatch(LayoutAction_1.default.onPureWhatsAppClicked()); },
}); };
var callOrEmail = function (props) {
    var allowedPages = [
        Pages_1.Pages.AGENT_PROFILE,
        Pages_1.Pages.SEARCH,
        Pages_1.Pages.BUILDING,
        Pages_1.Pages.DEVELOPMENTS,
        Pages_1.Pages.PROPERTY_DETAIL,
    ];
    if (allowedPages.indexOf(props.page) === -1)
        return null;
    var href = 'tel:21020888';
    if (props.phone) {
        href = "tel:" + props.phone.replace(' ', '');
    }
    return (React.createElement("div", { className: "c-calloremail" },
        React.createElement("a", { id: "footerEmail", onClick: props.enquireClicked, className: "c-calloremail__item c-calloremail__item--main" },
            React.createElement("span", { className: "fal fa-envelope" }),
            props.t.message),
        React.createElement("a", { id: "footerCall", onClick: props.whatsAppClicked, className: "c-calloremail__item c-calloremail__item--wa", target: "_blank" },
            React.createElement("span", { className: "o-btn-whatsapp-icon" }),
            "WhatsApp"),
        React.createElement("a", { id: "footerPureCall", onClick: props.callClicked, className: "c-calloremail__item c-calloremail__item--phone", target: "_blank" },
            React.createElement("span", { className: "fal fa-phone" }),
            "2102 0888")));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(callOrEmail);
